module.exports = __webpack_public_path__ + "assets/img/wjxd2.e07f4358.jpg";